import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white">
        <div className="surface rounded-md px-6 py-4 flex items-center gap-3">
          <div className="w-2 h-2 rounded-full bg-[#00E676] pulse-dot" />
          <span className="font-mono text-sm">Authenticating…</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace state={{ from: location }} />;
  return children;
}
